module.exports = __webpack_public_path__ + "img/delete.e85ec965.svg";